<template>
  <div class="content-wrap">
    <div class="wraper">
      <img class="t-img" :src="img" />
      <div class="condition">
        <div class="condition-item">
          <div class="condition-label">工作地点</div>
          <div class="condition-list" @click="trigger('city')">{{conditionCity}}</div>
          <span id="city" style="display:none;"></span>
        </div>
        <div class="condition-item">
          <div class="condition-label">招聘职位</div>
          <div class="condition-list subtype" @click="trigger('subtype')">{{conditionSubtype}}</div>
          <span id="subtype" style="display:none;"></span>
        </div>
        <div class="condition-item">
          标记<span class="star-icon"></span>的岗位，应届生都可以申请
        </div>
      </div>
      <div class="job-list">
        <div
          class="job-item"
          v-for="(item, index) in jobFilterList"
          :key="index"
          @click="setActive(item.id)"
        >
          <router-link to="/Job/JobDetail" class="link">
            <div class="job-head">
              <div class="head-content">
                <div class="job-title">
                  <span class="star-icon" v-if="!!item.star"></span>
                  {{item.position}}
                </div>
                <div class="base-info" v-html="item.baseHtml"></div>
              </div>
              <div class="img-wrap">
                <img src="../../assets/img/select.png" class="head-icon" />
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
import _lo from 'lodash'
import MobileSelect from "mobile-select";
export default {
  computed: {
    jobList() {
      return this.$store.state.jobList;
    },
    typeList() {
      return this.$store.state.jobNav || [];
    },
  },
  data() {
    return {
      img: `${process.env.BASE_URL}ImgFiles/top-hyjr_04.jpg`,
      posList: [
        {city: -1, name: "全部"      },
        {city: 1, name: "上海总部"    },
        {city: 3, name: "苏州研发中心"},
        {city: 0, name: "大连研发中心"},
        // {city: 2, name: "深圳代表处"  }
      ],
      subtypeList: [],
      conditionCity: '全部',
      cityId: -1,
      conditionSubtype: '全部',
      subtypeId: 0,
      jobFilterList: [],  // 筛选后的list

      city: null,
      subtype: null,
    }
  },
  methods: {
    setActive(id) {
      this.$store.commit("setDetailid", id);
    },
    // 过滤列表
    filterList(cityId, subtypeId) {
      this.jobFilterList = this.jobList.filter(item=>{
        return (_lo.includes(item.city_arr, cityId) || cityId == -1) &&
          (subtypeId == item.typeSub || subtypeId == 0);
      });
      // console.log(this.jobFilterList);
    },
    trigger(type) {
      document.getElementById(type).click();
    }
  },
  mounted() {
    this.filterList(-1, 0);
    this.city = new MobileSelect({
      trigger: "#city",
      wheels: [{ data: this.posList }],
      keyMap: {
        id: 'city',
        value: 'name'
      },
      callback: (indexArr, data) => {
        this.cityId = data[0].city;
        this.conditionCity = data[0].name;
        this.filterList(this.cityId, this.subtypeId);
      },
    });
    this.subtype = new MobileSelect({
      trigger: "#subtype",
      wheels: [
        { data: [
          {type: 0, name: '全部'},
          ...this.typeList
        ] }
      ],
      keyMap: {
        id: 'type',
        value: 'name'
      },
      callback: (indexArr, data) => {
        this.subtypeId = data[0].type;
        this.conditionSubtype = data[0].name;

        this.filterList(this.cityId, this.subtypeId);
      },
    });
  },
  beforeDestroy() {
    this.city.destroy();
    this.subtype.destroy();
  },
  watch: {
    typeList(val) {
      this.subtype.updateWheel(0, [{type: 0, name: '全部'}, ...val]);
    },
    jobList(val) {
      this.filterList(-1, 0);
    },
  }
};
</script>

<style scoped>
.content-wrap {
  /* top: 0;
  position: absolute;
  bottom: 0; */
  overflow-y: auto;
  /* left: 0;
  right: 0; */
  display: flex;
  display: -webkit-box; 
  display: -webkit-flex;
  display: -ms-flexbox; 
  display: -moz-box; 
  display: -moz-flex; 
  justify-content: space-between;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  flex-direction: column;
  z-index: 11;
  background-color: #fff;
  width: 100%;
  height: 100%;
}
.wraper {
  display: flex;
  display: -webkit-box; 
  display: -webkit-flex;
  display: -ms-flexbox; 
  display: -moz-box; 
  display: -moz-flex; 
  flex-direction: column;
  flex: 1 0 auto;
  -webkit-box-flex: 1 0 auto;
  -webkit-flex: 1 0 auto;
}
.job-list {
  padding: 0.3386rem 0.3386rem 1.6933rem 0.3386rem;
  background-color: rgb(247, 247, 247);
  flex: 1 0 auto;
  -webkit-box-flex: 1 0 auto;
  -webkit-flex: 1 0 auto;
}
.link {
  text-decoration: none;
}
.job-item {
  margin-bottom: 0.3386rem;
  background-color: #fff;
  width: 100%;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}
.job-head {
  padding: 0.2116rem;
  border-bottom: 1px rgb(225, 225, 225) solid;
  display: table;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.head-content {
  display: table-cell;
  vertical-align: middle;
  height: 2.79rem;
  padding-left: 0.3rem;
}
.job-title {
  font-size: 0.593rem;
  color: rgb(59, 59, 59);
  font-weight: bold;
  margin-bottom: 0.2116rem;
}
.base-info {
  font-size: 0.508rem;
  color: rgb(103, 103, 103);
  line-height: 0.8rem;
}
.img-wrap {
  height: 2.79rem;
  display: table-cell;
  vertical-align: middle;
  width: 1.1rem;
}
.head-icon {
  vertical-align: middle;
  width: 0.9rem;
}
.condition {
  padding: 0.808rem 0 0.898rem 0.4rem;
  background: #fff;
  box-sizing: border-box;
}
.condition-item {
  display: flex;
  display: -webkit-box; 
  display: -webkit-flex;
  display: -ms-flexbox; 
  display: -moz-box; 
  display: -moz-flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  align-items: center;
  font-size: 0.487rem;
  margin-bottom: 0.526rem;
}
.condition-item:last-child {
  margin-bottom: 0;
}
.condition-label {
  margin-right: 0.68rem;
}
.condition-list {
  width: 4.464rem;
  height: 1.116rem;
  background-color: #efefef;
  border-radius: 0.4rem;
  /* box-sizing: border-box; */
  line-height: 1.116rem;
  color: #464646;
  padding-left: 0.3rem;
  position: relative;
}
.condition-list:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0.244rem 0.244rem 0 0.244rem;
  border-color: #464646 transparent transparent transparent;
  right: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
}
.type {
  margin-right: 0.513rem;
}
.gw-img {
  height: 0.55rem;
  margin-left: .4rem;
  width: auto;
  object-fit: contain;
}
.star-icon {
  background: url(../../assets/img/star-icon.png) no-repeat center/auto;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.593rem;
  height: 0.593rem;
  vertical-align: text-top;
}
</style>